import { useEffect, useRef } from 'react';
import * as PIXI from 'pixi.js';
import { CANVAS_WIDTH, CANVAS_HEIGHT } from '../constants';
import { GameEngine } from '../game/GameEngine';
import { Entity } from '../game/Entity';

interface GameCanvasProps {
  currentDimension: number;
  onEngineReady: (engine: GameEngine) => void;
}

export function GameCanvas({ currentDimension, onEngineReady }: GameCanvasProps) {
  const canvasRef = useRef<HTMLDivElement>(null);
  const engineRef = useRef<GameEngine | null>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const app = new PIXI.Application();
    let mounted = true;

    (async () => {
      await app.init({
        width: CANVAS_WIDTH,
        height: CANVAS_HEIGHT,
        backgroundColor: 0x000000,
        antialias: false
      });

      if (!mounted || !canvasRef.current) return;

      canvasRef.current.appendChild(app.canvas as HTMLCanvasElement);

      // Preload all entity textures
      await Entity.preloadAllTextures();

      const engine = new GameEngine(app);
      engineRef.current = engine;
      onEngineReady(engine);
    })();

    return () => {
      mounted = false;
      if (engineRef.current) {
        engineRef.current.destroy();
      }
    };
  }, [onEngineReady]);

  return (
    <div
      className={`game-container dim${currentDimension}`}
      ref={canvasRef}
    />
  );
}
